import { createSelector, Selector } from '@reduxjs/toolkit';

import { RootState } from '~/store';

import { GeneratedLinkState } from '.';

const selectSelf: Selector<RootState, GeneratedLinkState> = state => state.generatedLink;

export const selectGeneratedLink = createSelector(selectSelf, state => state.data);
